module.exports = __webpack_public_path__ + "img/V-R-4-load-standup-shadow.3a981408.png";